var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('Header',{attrs:{"title":'Blockbuster',"links":_vm.links}}),_c('div',{attrs:{"id":"blockbuster-content"}},[_c('Catalog')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }